<template>
  <scoped v-if="value">
    <Enumeration
      v-if="customerTypes"
      v-model:selection="value.type"
      title="Type"
      :options="customerTypes"
      :readOnly="readOnly"
      @update="updateNumber()"
    />
    <TextInput
      v-model:value="value.name"
      title="Name"
      :readOnly="readOnly"
    />
    <NumberInput
      v-model:value="value.number"
      title="Number"
      :readOnly="readOnly"
    />
    <TextInput
      v-model:value="value.memorandum"
      title="Memorandum"
      multiline
      :readOnly="readOnly"
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import NumberInput from "@/components/inputs/number.vue"
  import TextInput from "@/components/inputs/text.vue"
  import {onBeforeMount, PropType, ref} from "vue"
  import {Customer} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import {Customer as CustomerClient} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import ErrorModal from "@/components/modals/error.vue"
  import Enumeration from "@/components/selectors/enumeration.vue"
  
  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  onBeforeMount(() => {
    read()
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<Customer>
  })

  const error = ref<Error>(null)
  const enumerationClient = new EnumerationClient()
  const customerClient = new CustomerClient()
  const customerTypes = ref<string[]>(null)

  async function read() {
    try {
      const response = await enumerationClient.readCustomerEnumerations()
      customerTypes.value = response.types
    } catch(e) {
      error.value = e
    }
  }

  async function updateNumber() {
    try {
      value.value.number = await customerClient.newNumber()
    } catch(e) {
      error.value = e
    }
  }
</script>
